/* src/app/admin-dashboard/site-system/records/transaction-view/transaction-view.component.css */
table {
  width: 100%;
}
.mat-mdc-form-field {
  font-size: 14px;
  width: 100%;
}
th.mat-sort-header-sorted {
  color: black;
}
.transSuccessful {
  color: green;
}
.transFail {
  color: red;
}
/*# sourceMappingURL=transaction-view.component.css.map */
